import { render, staticRenderFns } from "./4mStatus.vue?vue&type=template&id=149a8d5c"
import script from "./4mStatus.vue?vue&type=script&lang=js"
export * from "./4mStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149a8d5c')) {
      api.createRecord('149a8d5c', component.options)
    } else {
      api.reload('149a8d5c', component.options)
    }
    module.hot.accept("./4mStatus.vue?vue&type=template&id=149a8d5c", function () {
      api.rerender('149a8d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mStatus.vue"
export default component.exports